import accounting from 'accounting';

import currencyList from '../currencyList';

const optionalSign = (str) => {
  if (str.includes('+')) return '+';

  const dash = String.fromCharCode(8211);
  if (str.includes('-') || str.includes(dash)) return '-';

  return '';
};

const parsePrice = (priceString, decimalSeparator) => {
  const maybeMatchedPrice = priceString
    .replace(/&nbsp;/g, '')
    .replace(/\u00a0/g, '')
    .match(/\d+([0-9 .,]+)?/gi);

  if (!maybeMatchedPrice) {
    return null;
  }

  const price = accounting.unformat(maybeMatchedPrice[0], decimalSeparator);
  return parseFloat(price);
};

const convertPrice = (price, rate, fixedDigits) => {
  if (price === 0) return 0;

  const decimalFactor = Math.pow(10, fixedDigits);
  const convertedPrice =
    Math.round(price * rate * decimalFactor) / decimalFactor;
  if (convertedPrice === 0) {
    return 1 / decimalFactor;
  }
  return convertedPrice;
};

const detectSymbol = (symbols) => {
  return symbols.prefix || symbols.suffix;
};

const detectFormat = (symbols) => {
  return symbols.prefix ? '%s%v' : '%v%s';
};

const translatePrice = (htmlPrice, config) => {
  const {
    rate,
    targetCurrency,
    storeProfile: {
      formatsAndUnits: { currencyDecimalSeparator, currencyGroupSeparator },
    },
  } = config;

  const { symbols, fixedDigits } = currencyList.find(
    ({ code }) => code === targetCurrency
  );

  const price = parsePrice(htmlPrice, currencyDecimalSeparator);
  const convertedPrice = convertPrice(price, rate, fixedDigits);

  const formatOptions = {
    symbol: detectSymbol(symbols),
    decimal: currencyDecimalSeparator,
    thousand: currencyGroupSeparator,
    precision: fixedDigits,
    format: detectFormat(symbols),
  };

  const formattedPrice = accounting.formatMoney(convertedPrice, formatOptions);

  const sign = optionalSign(htmlPrice);
  const priceWithSign = `${sign}${formattedPrice}`;
  const nonBreakingSpace = '\u00a0';
  const resultedPrice = priceWithSign.replace(/ /g, nonBreakingSpace);
  return resultedPrice;
};

export { translatePrice };
